import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationService } from '../../../core/service/navigation.service';

@Component({
    selector: 'app-new-dashboard-item',
    templateUrl: './new-dashboard-item.component.html',
    styleUrls: ['./new-dashboard-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewDashboardItemComponent implements OnInit {
  constructor(private _navigation: NavigationService) {}

  ngOnInit(): void {}
}
